import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const getConfig = () => api.get("/config").then((r) => r.data);
export const getCourses = () => api.get("/courses").then((r) => r.data.courses);
export const getCourse = (id) => api.get(`/courses/${id}`).then((r) => r.data);
export const submitAssessment = (answers) =>
  api.post("/assessment", { answers }).then((r) => r.data);
export const createEnrollment = (payload) =>
  api.post("/enrollments", payload).then((r) => r.data);
export const confirmPayment = (enrollmentId, payload = {}) =>
  api.post(`/enrollments/${enrollmentId}/pay`, payload).then((r) => r.data);
export const claimPayment = (enrollmentId) =>
  api.post(`/enrollments/${enrollmentId}/claim`).then((r) => r.data);
export const bookCounselling = (payload) =>
  api.post("/counselling", payload).then((r) => r.data);
